import Vue from 'vue';
import VueRouter from 'vue-router';
import { ratingList } from '@/api/base';
import { createPcAdaptiveView, isPcClient } from '@/views/PC/utils';
import { normalizeWxCallbackUrl } from '@/utils/wechatAuth';
//index
const isPcView = isPcClient();
const main = isPcView ? () => import('@/views/PC/Main') : () => import('@/views/main/main');
const mainPost = isPcView
  ? () => import('@/views/PC/MainPost')
  : () => import('@/views/createPost/index');
const wrapPcView = (loader, options) => createPcAdaptiveView(loader, options);
// 404

const index = () => import(/* webpackChunkName: "404" */ '@/views/index/index');
const NotFound = wrapPcView(() => import(/* webpackChunkName: "404" */ '@/views/404/index'), {
  title: '页面不存在',
  description: '该链接在 PC 端未找到对应页面，请检查链接是否正确。',
  wide: false,
});

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    meta: { title: '一尘盯盘' },
    component: main,
    children: [
      {
        path: '',
        component: () => import('@/views/plate/index'),
        meta: { title: '', keepAlive: true },
      },
    ],
  },
  {
    path: '/login',
    meta: { title: '登录中' },
    component: wrapPcView(() => import('@/views/auth/index'), {
      title: '登录中',
      description: '',
      wide: false,
    }),
  },
  {
    path: '/index',
    meta: { title: '' },
    component: main,
    children: [{ path: '', component: index, meta: { title: '一尘盯盘' } }],
  },
  {
    path: '/plate',
    meta: { title: '' },
    component: main,
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('@/views/plate/index'),
        meta: { title: '看一尘网', keepAlive: true },
      },
      {
        path: 'list',
        name: 'plateList',
        component: () => import('@/views/plate/list'),
        meta: { title: '版块信息', keepAlive: true },
      },
    ],
  },
  {
    path: '/user',
    meta: { title: '' },
    component: main,
    children: [
      { path: '', component: () => import('@/views/user/index'), meta: { title: '个人中心' } },
    ],
  },
  {
    path: '/subscribe',
    component: wrapPcView(() => import('@/views/personal/index')),
    meta: { title: '我的盯盘' },
  },
  {
    path: '/posts',
    component: main,
    children: [
      { path: '', name: 'posts', component: () => import('@/views/plate/posts'), meta: {} },
    ],
  },
  {
    path: '/follow',
    component: wrapPcView(() => import('@/views/personal/followList')),
    meta: { title: '我的关注帖' },
  },
  {
    path: '/vip',
    component: wrapPcView(() => import('@/views/vip/index')),
    meta: { title: '开通会员' },
  },
  {
    path: '/ycRegistry',
    component: wrapPcView(() => import('@/views/registry/index')),
    meta: { title: '一尘注册' },
  },
  {
    path: '/hot',
    component: wrapPcView(() => import('@/views/hot/index')),
    meta: { title: '热搜' },
  },
  {
    path: '/blacklist',
    component: wrapPcView(() => import('@/views/blacklist/index')),
    meta: { title: '黑名单' },
  },
  {
    path: '/ranking',
    component: main,
    children: [
      {
        path: '',
        name: 'posts',
        component: () => import('@/views/hotRanking/index'),
        meta: { title: '盘口数据' },
      },
    ],
  },
  {
    path: '/activity',
    component: wrapPcView(() => import('@/views/activity/index')),
    meta: { title: '分享赚现金' },
  },
  {
    path: '/temporary-discount-qr',
    component: wrapPcView(() => import('@/views/temporaryDiscountQr/index'), {
      title: '折扣二维码',
      description: '创建和管理代理商折扣二维码。',
      wide: false,
    }),
    meta: { title: '折扣二维码' },
  },
  {
    path: '/share',
    component: wrapPcView(() => import('@/views/activity/share')),
    meta: { title: '一尘盯盘助手代理通道' },
  },
  {
    path: '/yclogin',
    component: wrapPcView(() => import('@/views/login/index'), {
      title: '一尘账号授权登录',
      description: '',
      wide: false,
    }),
    meta: { title: '一尘账号授权登录' },
  },

  {
    path: '/createPost',
    component: main,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/post'),
        meta: { title: '发帖' },
      },
    ],
  },
  {
    path: '/createPost',
    component: main,
    children: [
      {
        path: 'list',
        name: '',
        component: () => import('@/views/createPost/list'),
        meta: { title: '手机发帖' },
      },
    ],
  },
  {
    path: '/reply',
    component: mainPost,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/reply'),
        meta: { title: '回复' },
      },
    ],
  },
  {
    path: '/postList',
    component: wrapPcView(() => import('@/views/createPost/postList')),
    meta: { title: '发帖列表' },
  },
  {
    path: '/promotion',
    component: wrapPcView(() => import('@/views/ad/index')),
    meta: { title: '诚邀合作' },
  },
  {
    path: '/adView',
    component: wrapPcView(() => import('@/views/ad/view')),
    meta: { title: '详情' },
  },
  {
    path: '/postView',
    component: mainPost,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/postView'),
        meta: { title: '详情', keepAlive: true },
      },
    ],
  },
  {
    path: '/partake',
    component: mainPost,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/postView'),
        meta: { title: '我参与的帖子', keepAlive: true },
      },
    ],
  },
  {
    path: '/score',
    component: mainPost,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/createPost/score'),
        meta: { title: '帖子评分' },
      },
    ],
  },
  {
    path: '/participates',
    component: wrapPcView(() => import('@/views/createPost/participates')),
    meta: { title: '我参与的帖子' },
  },
  {
    path: '/ratingList',
    component: wrapPcView(() => import('@/views/createPost/ratingList')),
    meta: { title: '评分列表' },
  },
  {
    path: '/coin',
    component: wrapPcView(() => import('@/views/coin/index')),
    meta: { title: '纪念币实时走势' },
  },
  {
    path: '/caishendao',
    component: wrapPcView(() => import('@/views/caishendao/index'), {
      title: '公众号：一尘盯盘助手(实时盘口)',
      description: '查看一尘网当日买盘、卖盘与成交数据，每10秒自动更新。',
    }),
    // 缓存盘口列表，进入帖子详情再返回时可恢复原浏览位置。
    meta: { title: '公众号：一尘盯盘助手(实时盘口)', keepAlive: true },
  },
  {
    path: '*',
    component: NotFound,
    meta: { title: '页面不存在' },
  },
];

// 在 Vue Router 解析首个路由前修复重复井号，否则回调 query 会被误当成二级 hash。
const normalizedCallbackUrl = normalizeWxCallbackUrl(window.location.href);
if (normalizedCallbackUrl !== window.location.href) {
  window.history.replaceState(window.history.state, '', normalizedCallbackUrl);
}

const router = new VueRouter({
  routes,
});

// 发版后旧版本的懒加载 chunk 会被删除，正在使用的用户切换路由时加载失败会白屏
// 检测到 chunk 加载失败时刷新页面拉取最新 index.html：
// 1. URL 带时间戳参数，绕过浏览器/CDN 对 index.html 的缓存（参数在 # 之前，不影响 hash 路由）
// 2. sessionStorage 记录刷新时间，10 秒内不重复刷新，防止极端情况下的刷新死循环
router.onError(error => {
  const message = error && error.message ? error.message : String(error || '');
  if (/Loading (CSS )?chunk .* failed|ChunkLoadError/i.test(message)) {
    const lastReload = Number(sessionStorage.getItem('chunk_reload_time') || 0);
    const now = Date.now();
    if (now - lastReload > 10000) {
      sessionStorage.setItem('chunk_reload_time', String(now));
      window.location.replace(`${window.location.pathname}?_v=${now}${window.location.hash}`);
    }
  }
});

export default router;
